import React from 'react'

import CountUp from 'react-countup'

import client1 from '../assets/images/client/login.jpg'
import client2 from '../assets/images/client/anasayfa.jpg'
import client3 from '../assets/images/client/gruplar.jpg'
import client4 from '../assets/images/client/destek.jpg'
import client5 from '../assets/images/client/kesfet.jpg'
import client6 from '../assets/images/client/profil.jpg'
 

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css'

import { FiDownload } from 'react-icons/fi'

export default function BannerOne() {
    let images = [
        client1, client2, client3, client4, client5, client6
    ];

    const settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 0,
      };

  return (
    <section className="relative overflow-hidden md:py-36 py-24 bg-red-500/10 before:content-[''] before:absolute md:before:bottom-[30rem] sm:before:bottom-[35rem] xl:before:right-[13rem] lg:before:-right-[13rem] md:before:-right-[16rem] sm:before:-right-[15rem] before:w-[55rem] before:h-[25rem] before:rotate-[100deg] before:bg-gradient-to-r before:to-transparent before:via-red-500/50 before:from-red-500 before:z-1" id="home">
        <div className="container relative z-1">
            <div className="grid md:grid-cols-2 grid-cols-1 items-center mt-6 gap-[30px] relative">
                <div className="md:me-6">                    <h4 className="font-bold lg:leading-normal leading-normal text-[42px] lg:text-[54px] mb-5">Hatim Takip Uygulaması </h4>
                    <p className="text-slate-400 text-lg max-w-xl">Bireysel veya grup halinde Kur’an-ı Kerim ve Risale-i Nur Külliyatı okuma süreçlerini kolaylaştıran, otomatik cüz ve risale atama ile gelişmiş takip özelliklerine sahip kullanıcı dostu bir mobil uygulamadır.</p>
                </div>

                <div className="relative">
                    <div className="mx-auto w-80">
                        <div className="tiny-single-item">
                            <TinySlider settings={settings}>
                                {images.map((item:string, index:number)=>{
                                    return(
                                        <div className="tiny-slide" key={index}>
                                            <img src={item} alt=""/>
                                        </div>
                                    )
                                })}
                            </TinySlider>
                        </div>
                    </div>

                    <a href="https://expo.dev/artifacts/eas/2GRj8TuCDbUNLWsuRehcP6.apk" target="_blank" rel="noopener noreferrer" className="absolute bottom-28 md:start-5 -start-5 p-4 rounded-lg shadow-md dark:shadow-gray-800 bg-white dark:bg-slate-900 w-56 m-3 mover block">
                        <div className="flex items-center">
                            <div className="flex items-center justify-center size-[65px] bg-red-500/5 text-red-500 text-center rounded-full me-3">
                                <FiDownload className="size-6"/>
                            </div>
                            <div className="flex-1">
                                <h6 className="text-slate-400">Toplam İndirilme</h6>
                                <p className="text-xl font-bold"><CountUp className="counter-value" end={45485}/></p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
  )
}
